import InstanceIntegrationLogs from './InstanceIntegrationLogs';

export default InstanceIntegrationLogs;